import { ConnectionNames } from "../../../contracts";
import { ConfigStore, storeToken, getErrorDescription } from "../../../common";
export class BaseSportsSubscriber {
    constructor(onDataCallback, onErrorCallback) {
        var _a, _b, _c, _d;
        this.name = "subscribe";
        this.query = undefined;
        this.onDataCallback = onDataCallback;
        this.onErrorCallback = onErrorCallback;
        this.reconnects = 0;
        this.timeoutForReconnect;
        this.socketRetryDelay = (_b = (_a = ConfigStore.config.urls.SportsbookConnection) === null || _a === void 0 ? void 0 : _a.socketRetryDelay) !== null && _b !== void 0 ? _b : ConfigStore.config.socketRetryDelay;
        this.socketMaxRetryDelay = (_d = (_c = ConfigStore.config.urls.SportsbookConnection) === null || _c === void 0 ? void 0 : _c.socketMaxRetryDelay) !== null && _d !== void 0 ? _d : ConfigStore.config.socketMaxRetryDelay;
    }
    onData(x) {
        if (x) {
            this.reconnects = 0;
            this.onDataCallback(x);
        }
    }
    getLocale() {
        var _a;
        return ((_a = ConfigStore.config.urls.SportsbookConnection) === null || _a === void 0 ? void 0 : _a.queryParams.locale) || "en-US";
    }
    getName() {
        return this.name;
    }
    get clientMetadata() {
        return {
            "X-Client-Name": ConfigStore.config["X-Client-Name"],
            "X-Client-Version": ConfigStore.config["X-Client-Version"],
        };
    }
    onError(e) {
        this.onErrorCallback(e);
        ConfigStore.config.requestToken().then(token => {
            storeToken(token);
            clearTimeout(this.timeoutForReconnect);
            this.timeoutForReconnect = setTimeout(() => {
                this.reconnects = this.reconnects + 1;
                this.reInitQuery();
            }, Math.min((this.reconnects * this.socketRetryDelay), this.socketMaxRetryDelay));
        }).catch((error) => {
            ConfigStore.config.tracking[ConnectionNames.sports].trackError({
                message: `Token request failed with reason: ${getErrorDescription(error)}`,
                clientAction: "TOKEN_REQUEST_ERROR",
            });
        });
    }
    deactivate() {
        this.query = undefined;
    }
    reInitQuery() {
        const currentQuery = this.query;
        // TODO: Handle different error types as part of: https://jira.dkcorpit.com/browse/SBW-6751
        // For now ensure to reinit only when query exists or the last query was subscribe
        if (currentQuery && currentQuery.name === "subscribe") {
            this.query = undefined;
            this.query = Object.assign(Object.assign({}, currentQuery), { params: Object.assign({}, currentQuery.params) });
            ConfigStore.config.tracking[ConnectionNames.sports].trackData({
                message: `Reinit query: ${JSON.stringify(this.query)} with token: ${ConfigStore.config.connections.jwt}`,
                clientAction: "RE_INIT_QUERY",
            });
        }
    }
}
//# sourceMappingURL=BaseSportsSubscriber.js.map